module.exports = __webpack_public_path__ + "img/card-services-month-certification.07aa0dcc.svg";